import {
  DAY_KEY,
  getByIdDaysSelector
} from '@gymaholic/packages'
import updateReduxUtil from 'modules/redux/utils/update'
import { getWorkoutsByIdDaySelector } from 'modules/day/redux/selectors/getWorkoutsById/index.js'

export const getDeepByIdDaySelector = dayId => (state) => {
  const day = getByIdDaysSelector(dayId)(state)
  return updateReduxUtil(
    day,
    {
      [DAY_KEY.WORKOUTS]: getWorkoutsByIdDaySelector(dayId)(state)
    }
  )
}
